/* eslint-disable */
import clsx from "clsx";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MHWhiteLogo } from "../../../assets/Icons";
import Button from "../Button";
import Cookies from "universal-cookie";
import { isMasterVendor } from "../../../store";
import { signOut } from "../../../services/auth";
import { Mixpanel } from "../../../constants/mixpanel";
import { useRecoilState } from "recoil";
import { getMhReferenceId } from "../../../services/navigate/getMhRefId";

interface ConveraPaymentProps {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  country?: string;
  institution: string;
}

const cookies = new Cookies();

export const Header = () => {
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const [masterVendor,setMasterVendor] = useRecoilState(isMasterVendor);
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const everestPartner = localStorage.getItem("everestPartner");

  const commonButtonList = [
    { btnText: "Fx Rates", pathName: "/fxrates", track: "Fx_rates" },
    { btnText: "Initiate Transaction", pathName: "/remittance", track: "Initiate_transaction" },
    { btnText: "History", pathName: "/history", track: "History" },
  ];

  
  let defaultButtonList = [...commonButtonList];
  
  // Master Vendor = true & No Everest Vendor
  if (masterVendor && everestPartner === null || masterVendor && !everestPartner || masterVendor && everestPartner === "false") {
    defaultButtonList.push(
      { btnText: "Margin", pathName: "/margin", track: "Margin" },
      { btnText: "Commissions", pathName: "https://books.zohosecure.in/portal/moneyhop", track: "Commissions" },
      { btnText: "Sub Vendor", pathName: "/subvendor-margin", track: "Sub_vendor_margin" }
    );
  }
  
  // Master Vendor = true & Everest Vendor = true
  else if (masterVendor && everestPartner) {
    defaultButtonList.push({ btnText: "Sub Vendor", pathName: "/subvendor-margin", track: "Sub_vendor_margin" });
  }
  
  // Master Vendor = false & No Everest Vendor
  else if (masterVendor === false && everestPartner === 'false') {
    defaultButtonList.push({ btnText: "Margin", pathName: "/margin", track: "Margin" });
  }
  
  // Master Vendor = false & Everest Vendor = true
  else if (!masterVendor && everestPartner) {
    // defaultButtonList.push({ btnText: "Sub Vendor", pathName: "/subvendor-margin", track: "Sub_vendor_margin" });
  }
  
  
  const listItemClassname =
    "px-8 py-2 font-semibold text-black transition-all bg-white bg-gray-100 hover:bg-gray-200 z-50 transition-all";

  const handleLogout = () => {
    cookies.remove("XSRF-TOKEN");
    localStorage.clear();
    Mixpanel.track("Logout");
    Mixpanel.reset();
    sessionStorage.clear();
    signOut(currentUser)
      .then((response: any) => {
        if (response?.data) {
          setMasterVendor(false);
        }
      })
      .catch((error) => {
        {
          console.warn("Failed to logout..!", error);
        }
      })
      .finally(() => {
        navigate("/auth/sign-in");
      });
  };

  return (
    <div className="h-[90px] z-40 w-full bg-[#0F5BF1] flex justify-between items-center">
      <div
        onClick={() => navigate("/home")}
        id="logo"
        className="flex justify-start ml-32 cursor-pointer"
      >
        <MHWhiteLogo />
      </div>
      <div id="buttons">
        <div className="flex space-x-[32px] mr-[15vh]">
          {defaultButtonList.map((item, index) => (
            <Button
              key={index}
              className="text-[16px] bg-[#0F5BF1] text-white font-semibold group peer relative h-[90px]"
              onClickHandler={() => {
                if (item.pathName === "/remittance") {
                  setIsDropdownOpen(!isDropdownOpen);
                } else if (item.btnText === "Commissions") {
                  window.open(item.pathName, "_blank")
                }
                else {
                  navigate(item.pathName);
                  Mixpanel.track(item.pathName);
                }
              }}
            >
              {item.btnText}
              <div
                className={clsx(
                  item.btnText === "Initiate Transaction"
                    ? currentUser?.username?.includes("moneyhop.co")
                      ? "absolute flex-col hidden mt-[230px] w-[250px] group-hover:flex peer-hover:flex hover:flex shadow-xl shadow-gray-500 z-10 rounded"
                      : "absolute flex-col hidden mt-[150px] w-[250px] group-hover:flex peer-hover:flex hover:flex shadow-xl shadow-gray-500 z-10 rounded"
                    : "hidden"
                )}
              >
                <span
                  onClick={() => {
                    navigate("/remittance");
                    Mixpanel.track("Initiate_transaction_Online");
                  }}
                  className={listItemClassname}
                >
                  moneyHOP Online
                </span>
                <span
                  onClick={() => {
                    navigate("/convera")
                    Mixpanel.track("Initiate_convera_transaction_Online");
                  }}
                  className={listItemClassname}
                >
                  moneyHOP x Convera
                </span>
                <span
                  onClick={() => {
                    navigate("/flywire");
                    Mixpanel.track("Initiate_transaction_Flywire");
                  }}
                  className={listItemClassname}
                >
                  Flywire
                </span>
                {currentUser?.username?.includes("moneyhop.co") ? (
                  <>
                    <span
                      onClick={() => {
                        navigate("/offline");
                        Mixpanel.track("Initiate_transaction_Western_Union");
                      }}
                      className={listItemClassname}
                    >
                      Offline
                    </span>
                    <span
                      onClick={() => {
                        navigate("/travel-card");
                        Mixpanel.track("Initiate_transaction_Western_Union");
                      }}
                      className={listItemClassname}
                    >
                      Travel Card
                    </span>
                  </>
                ) : null}
              </div>
            </Button>
          ))}
          <div className="flex items-center justify-center">
            <Button
              onClickHandler={() => handleLogout()}
              className="font-semibold text-[16px] h-[40px] rounded-full text-white bg-[#FF820E]"
            >
              Logout
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
